"use client"

import { useTranslations } from "next-intl"
import { Pause, Play, X } from "@/lib/icons"
import { cn } from "@/lib/utils"
import { useGlobalPlaybackStore } from "@/lib/global-playback-store"

// Extracted from components/booru-detail-modal.tsx (pure move).
const PLAY_OPTIONS = { skipHSSP: false } as const

// Isolated — subscribes to currentScript/isPlaying so BooruDetailModal
// doesn't re-render every time a script loads or play state changes.
export function GlobalScriptBar({
  showScriptPlayer,
  onStop,
}: {
  showScriptPlayer: boolean
  onStop: () => void
}) {
  const tt = useTranslations("booruDetailModal")
  const globalCurrentScript = useGlobalPlaybackStore((s) => s.currentScript)
  const globalIsPlaying = useGlobalPlaybackStore((s) => s.isPlaying)
  const globalPlay = useGlobalPlaybackStore((s) => s.play)
  const globalPause = useGlobalPlaybackStore((s) => s.pause)

  if (!showScriptPlayer || !globalCurrentScript) return null

  return (
    <div className="mt-2 rounded-lg border bg-muted/40 px-3 py-2 flex items-center gap-2">
      <div className={cn(
        "h-2 w-2 rounded-full shrink-0",
        globalIsPlaying ? "bg-green-400 animate-pulse" : "bg-muted-foreground/40"
      )} />
      <span className="text-xs font-medium truncate flex-1 min-w-0">{globalCurrentScript.name}</span>
      <button
        type="button"
        title={globalIsPlaying ? tt("pause") : tt("resume")}
        onClick={() => globalIsPlaying ? globalPause() : globalPlay(PLAY_OPTIONS).catch(() => {})}
        className="h-6 w-6 shrink-0 rounded flex items-center justify-center hover:bg-accent transition-colors"
      >
        {globalIsPlaying
          ? <Pause className="h-3.5 w-3.5" />
          : <Play className="h-3.5 w-3.5" />}
      </button>
      <button
        type="button"
        title={tt("stop")}
        onClick={onStop}
        className="h-6 w-6 shrink-0 rounded flex items-center justify-center hover:bg-accent transition-colors"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
